export default "__VITE_PUBLIC_ASSET__92b08bb1__"